import React from 'react'
import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

type CurrencyPreviewProps = {
  readonly image: React.ReactNode
  readonly primary?: string
  readonly secondary?: string
  readonly tertiary?: string
  readonly links?: ReadonlyArray<React.ReactNode>
}
export const CurrencyPreview = (props: CurrencyPreviewProps) => (
  <Root>
    <div className="image">{props.image}</div>
    <div className="content">
      <div className="primary">
        <div className="primary-left">
          {props.primary ? (
            props.primary
          ) : (
            <Skeleton static height={14} width={'80%'} />
          )}
        </div>
        <div className="primary-right">
          {props.links && props.links.length > 0 ? (
            props.links
          ) : (
            <>
              <Skeleton static variant="circular" height={14} width={14} />
              <Skeleton static variant="circular" height={14} width={14} />
              <Skeleton static variant="circular" height={14} width={14} />
            </>
          )}
        </div>
      </div>
      <div className="secondary">
        {props.secondary ? (
          props.secondary
        ) : (
          <Skeleton static height={12} width={'30%'} />
        )}
      </div>
      <div className="tertiary">
        {props.tertiary ? (
          props.tertiary
        ) : (
          <>
            <Skeleton static height={10} width={'100%'} />
            <Skeleton static height={10} width={'90%'} />
          </>
        )}
      </div>
    </div>
  </Root>
)

const Root = styled.div`
  border: 1px solid #323232;
  border-radius: 14px;
  padding: 10px;
  display: grid;
  grid-template-columns: max-content auto;
  gap: 10px;
  position: relative;

  background: var(--background-3, #222222);

  .image {
    margin: 4px 0 0 0;
    width: 64px;
    height: 64px;
  }

  .content {
    padding: 4px 0 0 0;
  }

  .primary {
    gap: 20px;
    display: grid;
    grid-template-columns: 1fr auto;
  }

  .primary-left {
    word-break: break-word;
    flex: 0 0 auto;
    gap: 8px;
    color: var(--text-12, white);
    font-size: 11px;
    font-weight: 700;
    /* min-width: 0; */
  }
  .primary-right {
    flex: 0 0;
    gap: 8px;
    display: flex;
  }
  .secondary {
    color: var(--text-11, #b4b4b4);
    word-break: break-word;
    margin-top: 3px;
    max-width: 100%;
    font-size: 10px;
    font-weight: 500;
  }
  .tertiary {
    color: var(--text-9, #6e6e6e);
    word-break: break-word;
    margin-top: 5px;
    display: grid;
    gap: 3px;
    font-size: 10px;
    font-weight: 400;
  }
`
